<template>
	<app-section class="flex flex-col">
		<div class="flex items-center justify-between">
			<span class="font-semibold text-xl">Menu</span>
			<!--			<app-button class="btn btn-transparent" icon="plus" @click="$emit('addCustomItem')">Custom item</app-button>-->
		</div>
		<div>
			<app-input
				class="flex flex-1"
				name="search"
				v-model="search"
				placeholder="Search for product"
				icon="search"
				:hide-label="true"
			/>
			<app-scrollable>
				<div class="flex flex-row overflow-none">
					<div
						class="flex flex-1 pt-1 pb-2 mx-1 items-center border-b-2 justify-center cursor-pointer"
						:class="{
							'border-primary': category.id === selectedCategory,
							'border-border-color': category.id !== selectedCategory,
						}"
						style="min-width: 120px;"
						v-for="(category, index) in categories"
						:key="index"
						@click="filterByCategory(category)"
					>
						<div class="flex text-center">{{ category.menuCategory.categoryName }}</div>
					</div>
				</div>
			</app-scrollable>
			<div class="items-container">
				<div v-for="[id, category] in Object.entries(filteredProducts)" :key="id">
					<div class="font-semibold text-xl mt-5">{{ categoryName(id) }}</div>
					<div class="flex flex-col gap-5">
						<div
							class="flex flex-col gap-1 border-1 border-background rounded-md"
							v-for="product in category"
							:key="product.id"
						>
							<div
								:class="{
									'flex p-2': true,
									'cursor-pointer hover:bg-background': product.hasToppingTypes || product.hasVariant,
								}"
								@click="expandProduct(product)"
							>
								<div class="flex flex-1 flex-col justify-center">
									<p class="">{{ product['itemName'] }}</p>
									<p class="text-muted">{{ product['itemDescription'] }}</p>
									<div class="flex items-center gap-3">
										<span
											v-if="product.itemPrice < product.oldPrice"
											class="text-muted line-through"
										>
											{{ $filters.formatCurrency(product['oldPrice'], restaurantCurrency) }}
										</span>
										<span>
											{{ $filters.formatCurrency(product['itemPrice'], restaurantCurrency) }}
										</span>
									</div>
								</div>
								<div class="w-1/12 flex items-center">
									<img v-if="product.image" :src="$filters.setImage(product.image)" alt="" />
									<img v-else src="../../../assets/images/bab10vite.png" alt="" />
								</div>
							</div>
							<div
								v-if="!product.hasToppingTypes && !product.hasVariant"
								class="flex items-center justify-between"
							>
								<div class="border-p-light border-1 rounded-lg flex items-center">
									<app-icon
										@click="removeProduct(product, 1)"
										class="text-2xl cursor-pointer border-p-light text-success p-1"
										icon="minus"
									/>
									<div
										class="flex gap-3 px-2 border-l-1 border-r-1 border-p-light p-1 w-10 justify-center"
									>
										{{ product.quantity }}
									</div>
									<app-icon
										@click="addProduct(product)"
										class="text-2xl cursor-pointer border-p-light text-success p-1"
										icon="plus"
									/>
								</div>
								<app-button class="btn btn-success mt-3" @click="addToBasket(product)">
									<app-icon icon="shopping-basket" />
									<span class="ml-2">Add to basket</span>
								</app-button>
							</div>
							<div v-if="product.loading" class="flex justify-center p-2">
								<loading-spinner />
							</div>
							<div v-if="product.isExpanded && !product.loading" class="flex flex-col p-2">
								<div v-if="product.variant">
									<div class="font-semibold">{{ product.variant.description }}</div>
									<app-radio-group
										option-value="id"
										option-label="itemName"
										:options="product.variant.items"
										v-model="product.selectedVariantId"
									>
										<template #label="{option}">
											<div class="flex-1 flex items-center justify-between">
												<span class="text-13">{{ option.itemName }}</span>
												<div class="flex gap-3">
													<span
														v-if="option.price < option.oldPrice"
														class="text-muted line-through"
													>
														{{
															$filters.formatCurrency(
																option['oldPrice'],
																restaurantCurrency
															)
														}}
													</span>
													<span>
														{{
															$filters.formatCurrency(option['price'], restaurantCurrency)
														}}
													</span>
												</div>
											</div>
										</template>
									</app-radio-group>
								</div>
								<app-line />
								<div v-if="product.toppingTypes" class="flex flex-col gap-2">
									<span class="font-semibold">Toppings</span>
									<div v-for="topping in product.toppingTypes" :key="topping.id">
										<div class="font-semibold text-muted">
											{{ topping.description }}
											<span class="text-13">{{ topping.required && '(Required)' }}</span>
										</div>
										<div v-for="item in topping.items" :key="item.id" class="flex justify-between">
											<app-checkbox :label="item.itemName" v-model="item.isSelected" />
											<div class="flex gap-2">
												<!--											<span v-if="item.price < item.oldPrice" class="text-muted line-through">-->
												<!--												{{ $filters.formatCurrency(item['oldPrice']) }}-->
												<!--											</span>-->
												<span class="text-13">
													{{ $filters.formatCurrency(item['price'], restaurantCurrency) }}
												</span>
												<div class="border-p-light border-1 rounded-lg flex items-center h-6">
													<app-icon
														@click="removeProduct(item, 1)"
														class="cursor-pointer border-p-light text-success"
														icon="minus"
													/>
													<div
														class="flex px-2 border-l-1 border-r-1 border-p-light w-10 justify-center"
													>
														{{ item.quantity }}
													</div>
													<app-icon
														@click="addProduct(item)"
														class="cursor-pointer border-p-light text-success"
														icon="plus"
													/>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div class="flex items-center justify-between">
									<div class="border-p-light border-1 rounded-lg flex items-center">
										<app-icon
											@click="removeProduct(product, 1)"
											class="text-2xl cursor-pointer border-p-light text-success p-1"
											icon="minus"
										/>
										<div
											class="flex gap-3 px-2 border-l-1 border-r-1 border-p-light p-1 w-10 justify-center"
										>
											{{ product.quantity }}
										</div>
										<app-icon
											@click="addProduct(product)"
											class="text-2xl cursor-pointer border-p-light text-success p-1"
											icon="plus"
										/>
									</div>
									<app-button class="btn btn-success mt-3" @click="addComplexToBasket(product)">
										<app-icon icon="shopping-basket" />
										<span class="ml-2">Add to basket</span>
									</app-button>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</app-section>
</template>

<script>
	import RestaurantService from '@/services/sales/BusinessService';
	import AppIcon from '@/components/app/AppIcon';
	import AppScrollable from '@/components/app/AppScrollable';
	import AppButton from '@/components/app/AppButton';
	import LoadingSpinner from '@/components/app/LoadingSpinner';
	import MenuService from '@/services/sales/MenuService';
	import AppLine from '@/components/app/AppLine';
	import AppRadioGroup from '@/components/app/AppRadioGroup';
	import AppCheckbox from '@/components/app/AppCheckbox';

	export default {
		name: 'MenuSection',
		components: { AppCheckbox, AppRadioGroup, AppLine, LoadingSpinner, AppButton, AppIcon, AppScrollable },
		emits: ['close', 'addToBasket'],
		props: ['businessId', 'customerId', 'order', 'existingProducts', 'restaurantCurrency'],
		data: () => ({
			loading: false,
			loadingProducts: false,
			search: '',
			selectedCategory: 0,
			products: [],
			categories: [],
		}),
		computed: {
			filteredProducts() {
				let results = [...this.products];
				if (this.selectedCategory) {
					results = results.filter((p) => p['menuRestaurantCategory'].id === this.selectedCategory);
				}
				if (this.search) {
					const search = this.search.toLowerCase();
					results = results.filter(
						(p) =>
							p['itemName'].toLowerCase().indexOf(search) > -1 ||
							p['itemDescription'].toLowerCase().indexOf(search) > -1
					);
				}
				return results.reduce((rv, x) => {
					(rv[x['menuRestaurantCategory']['id']] = rv[x['menuRestaurantCategory']['id']] || []).push(x);
					return rv;
				}, {});
			},
		},
		methods: {
			categoryName(id) {
				return this.categories?.find((cat) => cat.id === parseInt(id))?.menuCategory?.categoryName || '';
			},
			expandProduct(product) {
				if (!product.hasVariant && !product.hasToppingTypes) return;
				product.isExpanded = !product.isExpanded;
				if (!product.hasFullBody) {
					product.loading = !product.loading;
					MenuService.getMenuItemById(this.businessId, 'DELIVERY', product.id).then((res) => {
						const _product = {
							...product,
							...res,
							loading: false,
							isExpanded: true,
							hasFullBody: true,
							selectedVariantId: res?.variant?.items?.find((item) => item.isDefault).id,
							quantity: 1,
						};
						const productIndex = this.products.findIndex((prod) => prod.id === product.id);
						this.products[productIndex] = _product;
					});
				}
			},
			getProducts() {
				if (!this.businessId) return;
				this.emitter.emit('isLoading', true);
				RestaurantService.getProducts(this.businessId, this.customerId)
					.then((products) => {
						this.products = products.map((p) => {
							return {
								...p,
								quantity: 1,
							};
						});
						this.categories = this.extractCategoriesFromProducts(products);
					})
					.catch((error) => {
						this.$notificationService.error(error);
					})
					.finally(() => {
						this.emitter.emit('isLoading', false);
					});
			},
			extractCategoriesFromProducts(products) {
				const cat = [{ id: 0, menuCategory: { categoryName: 'All' } }];
				products.map((p) => {
					const i = cat.findIndex((c) => c.id === p['menuRestaurantCategory'].id);
					if (i === -1) {
						cat.push(p['menuRestaurantCategory']);
					}
				});
				return cat;
			},
			filterByCategory({ id }) {
				this.selectedCategory = id;
			},
			addProduct(product) {
				product.quantity += 1;
			},
			removeProduct(product, min = 1) {
				if (product.quantity === min) {
					return;
				}
				product.quantity -= 1;
			},
			addToBasket(product) {
				this.$emit('addToBasket', product);
			},
			addComplexToBasket(product) {
				const selectedVariantItem = product?.variant?.items?.find(
					(item) => item.id === product.selectedVariantId
				);
				const selectedToppingItems = product?.toppingTypes
					?.map((toppingType) =>
						toppingType.items
							.filter((item) => item.isSelected)
							.map((item) => ({
								id: item.id,
								toppingTypeId: toppingType.id,
								quantity: item.quantity,
								price: item.price,
								itemName: item.itemName,
							}))
					)
					.flat();

				const parsedProduct = {
					...product,
					variantItem: selectedVariantItem,
					toppingItems: selectedToppingItems,
					isComplex: true,
				};
				this.$emit('addToBasket', parsedProduct);
			},
		},
		mounted() {
			this.getProducts();
		},
		watch: {
			businessId() {
				this.getProducts();
			},
		},
	};
</script>

<style lang="scss" scoped>
	.items-container {
		@apply overflow-y-auto;
		max-height: calc(100vh - 300px);
	}
</style>
